import React, { useState } from 'react';

import StripeTipCheckout from '../organisms/StripeTipCheckout';
import { StripeTipCheckoutSelection, TipAmount } from '../../types';
import { brooksBrandProfile } from '../../branding/companyBrand';

const amounts: TipAmount[] = [
  { name: '$5', value: 5 },
  { name: '$10', value: 10 },
  { name: '$15', value: 15 },
];

const StripeTipPreview: React.FC = () => {
  const brand = brooksBrandProfile;
  const [error, setError] = useState<string | null>(null);

  const handleCheckout = (selection: StripeTipCheckoutSelection) => {
    const paymentLabel = selection.paymentOption === 'cash_app' ? 'Cash App Pay' : 'card or wallet checkout';

    setError(
      `Preview selected ${paymentLabel}. Customer pays $${selection.total.toFixed(2)} and technician receives $${selection.technicianTip.toFixed(2)}.`
    );
  };

  return (
    <StripeTipCheckout
      amounts={amounts}
      brand={brand}
      error={error}
      header="Thanks for your feedback!"
      onBack={() => window.history.back()}
      onCheckout={handleCheckout}
      onNoThanks={() => setError('No tip selected.')}
      subheader={`Would you like to leave a tip for ${brand.companyName}?`}
    />
  );
};

export default StripeTipPreview;
